<template>
  <div>
    <h4
      class="d-flex justify-content-between align-items-center w-100 font-weight-bold py-3 mb-4"
    >
      <div class="e-mtavr-15">ბილინგი</div>
    </h4>

    <div class="row">
      <div class="col-12">
        <div class="e-loader-back" v-if="usersLoading">
          <div class="e-loader-content">
            <div class="ball-clip-rotate-multiple">
              <div></div>
              <div></div>
            </div>
            <div class="e-nusx-8 e-bold e-loader-text">იტვირთება...</div>
          </div>
        </div>
        <vue-good-table
          ref="transactionsTable"
          :columns="transactionsTableColumns"
          :rows="transactionsTableRows"
          class="vgt-table bordered condensed e-table-1 e-dynamic-filter"
          :search-options="{
            enabled: true,
            placeholder: 'ძებნის პარამეტრი',
          }"
          :sort-options="{
            enabled: false,
            // initialSortBy: { field: 'id', type: 'asc' },
          }"
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 10,
            position: 'top',
            perPageDropdown: [15, 25, 50],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'შემდეგი',
            prevLabel: 'წინა',
            rowsPerPageLabel: 'ნაჩვენები ჩანაწერების რაოდენობა',
            ofLabel: '-ჩანაწერი სულ',
            pageLabel: 'გვერდი', // for 'pages' mode
            allLabel: 'ყველა',
          }"
        >
        <div slot="table-actions">
                   <b-button
                class="btn btn-link e-mtavr-17 btn-outline-secondary mr-2"
                v-b-modal.addNewTr
              >
                <i class="lnr lnr-file-add mr-2"></i> ახალი შესყიდვა
              </b-button>
               </div>
          <template slot="table-row" slot-scope="props">
            <div v-if="props.column.field == 'functions'" class="text-left">
              <b-btn
              v-if="props.row.statusID > 0"
                class="btn btn-xs btn-outline-success borderless icon-btn"
                v-b-modal.editUserDetails
                @click="EditUser(props.row)"
              >
                <i class="lnr lnr-pencil"></i>
              </b-btn>
              <!-- <b-btn
              v-if="props.row.statusID > 0"
                class="btn btn-xs btn-outline-secondary borderless icon-btn"
                v-b-modal.changePassword
                @click="ChangePassword(props.row)"
              >
                <i class="lnr lnr-cog"></i>
              </b-btn> -->
              <button
                type="button"
                class="btn btn-xs btn-outline-danger borderless icon-btn"
                @click="EditUser2Del(props.row)"
                v-if="props.row.statusID > 0"
              >
                <i class="lnr lnr-cross"></i>
              </button>
            </div>
            <div v-else-if="props.column.field == 'statusText'" class="text-right">
              <span v-if="props.row.status > 0" class="text-success e-nusx-8">დამუშავებული</span>
              <span v-if="props.row.status ===0" class="text-danger e-nusx-8">დასამუშავებელი</span>
            </div>
          </template>
        </vue-good-table>
      </div>
    </div>
    <!-- <add-new-user @UserAdded="GetOrgUsers()"></add-new-user> -->
    <add-new-tr></add-new-tr>
    <!-- <edit-user-details :EditUserDetails="UpdateUserItem"></edit-user-details> -->
    <!-- <change-password :changePasswordParams="changePasswordItem"></change-password> -->
  </div>
</template>
<script>
import BaseService from '@/backend/vue-axios/axios.js'
import addNewTr from './components/addNewTr.vue'
export default {
  name: 'investigatingrequest',
  components: {
    addNewTr
  },
  data () {
    return {
      loading: false,
      usersLoading: false,
      UpdateUserItem: {},
      changePasswordItem: {
        userName: '',
        id: 0,
        password: '',
        rePassword: ''
      },
      orgUsers: {},
      header: {
        headers: {
          accept: 'text/plain',
          Authorization: 'Bearer ' + this.$store.getters.getAccessToken
        }
      },
      transactionsTableColumns: [
        // {
        //   label: 'მომხმარებლის #',
        //   field: 'id',
        //   thClass: 'e-nusx-8 e-whitespace-nowrap e-ts-08rem',
        //   tdClass: 'e-eng-font e-ts-08rem',
        //   type: 'number'
        // },
        {
          label: 'ორგანიზაცია',
          field: 'orgName',
          thClass: 'e-nusx-8 e-whitespace-nowrap e-ts-08rem',
          tdClass: 'e-nusx-8 e-ts-08rem',
          type: 'text'
        },
        {
          label: 'კლიკების გამოყენების ბოლო ვადა',
          field: 'searchesEndDate',
          thClass: 'e-nusx-8 e-whitespace-nowrap e-ts-08rem',
          tdClass: 'e-nusx-8 e-ts-08rem',
          type: 'text'
        },
        {
          label: 'გასააქტიურებელი კლიკების რაოდენობა',
          field: 'transactionSearchCount',
          tdClass: 'e-eng-font e-ts-08rem e-bold',
          thClass: 'e-nusx-8 e-whitespace-nowrap e-ts-08rem',
          type: 'text'
        },
        // {
        //   label: 'წვდომის ტიპი',
        //   field: 'positionDesc',
        //   thClass: 'e-nusx-8 e-whitespace-nowrap e-ts-08rem',
        //   tdClass: 'e-nusx-8 e-ts-08rem',
        //   type: 'text'
        // },
        {
          label: 'სტატუსი',
          field: 'statusText',
          tdClass: 'e-eng-font e-ts-08rem',
          thClass: 'e-nusx-8 e-whitespace-nowrap e-ts-08rem',
          type: 'number'
        }
      ],
      transactionsTableRows: []
    }
  },
  created () {
    this.GetPurchaseTransactions()
  },
  computed: {
    currentUser () {
      return this.$store.getters.GetCurrentUser
    }
  },
  methods: {
    GetPurchaseTransactions () {
      this.loading = true
      BaseService.GetPurchaseTransactions(this.header).then((res) => {
        if (res.data.success) {
          console.log(res.data)
          this.transactionsTableRows = res.data.result
          this.loading = false
        }
      })
    },
    EditUser (user) {
      user.password = ''
      this.UpdateUserItem = user
    },
    ChangePassword (user) {
      this.changePasswordItem.id = user.id
      this.changePasswordItem.userName = user.userName
    },
    EditUser2Del (user) {
      this.$swal({
        icon: 'danger',
        title: 'ყურადღება!',
        html: '<span class="e-nusx-8 e-ts-09rem">თქვენ აუქმებთ მომხმარებლისთვის წვდომას!</span>',
        showCancelButton: false,
        confirmButtonColor: '#DD6B55',
        confirmButtonText: 'გასაგებია',
        heightAuto: false,
        keydownListenerCapture: true
      }).then((result) => {
        if (result.isConfirmed) {
          user.statusID = 0
          BaseService.EditUser(this.header, user)
            .then(res => {
              if (res.data.success) {
                console.log('გაუქმდა')
                this.GetOrgUsers()
              }
            })
        }
      })
    }
  }
}
</script>
